// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".preferences-profile-container[data-v-58d0a9e1]{flex:1;display:flex;flex-flow:column;padding-top:.5rem}.profile-container[data-v-58d0a9e1]{flex:1;overflow:auto;padding:1rem;max-width:48rem}@media only screen and (min-width:768px){.profile-container[data-v-58d0a9e1]{width:48rem;margin:0 auto}}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
